import type {MenuItem} from 'shared/components/kp-main-menu/types';
import type {Readable} from 'svelte/store';
import {writable} from 'svelte/store';
import {getContext, setContext} from 'svelte';

const erpSidebarNavCtxKey = 'erp-sidebar-ctx';

interface ErpSidebarNavContext {
    currentRoute: Readable<string>;
    menuItems: Readable<MenuItem[]>;
    setCurrentRoute: (routeUrl: string) => void;
    updateMenuItems: (newMenuItems: MenuItem[]) => void;
}

export function createErpSidebarNavContext(currentRouteUrl: string, currentMenuItems: MenuItem[]): ErpSidebarNavContext {
    const currentRoute = writable<string>(currentRouteUrl);
    const menuItems = writable<MenuItem[]>(currentMenuItems);

    return setContext<ErpSidebarNavContext>(erpSidebarNavCtxKey, {
        currentRoute,
        menuItems,
        setCurrentRoute: (routeUrl: string) => currentRoute.set(routeUrl),
        updateMenuItems: (newMenuItems: MenuItem[]) => menuItems.set(newMenuItems)
    });
}

export function getErpSidebarNavContext(): ErpSidebarNavContext {
    return getContext<ErpSidebarNavContext>(erpSidebarNavCtxKey);
}